export default "__VITE_ASSET__3d6d9c50__"